module.exports = "/assets/data/61e28ad88e7840a35446d591854f551a-GL50.data.json";